import styled from "styled-components";
import theme from "~/styles/theme";

export const Calendar = styled.div`
  font-family: ${theme.typography.JohnsonsBaby};
  position: relative;
  background: white;
  padding-top: 100px;
  padding-bottom: 50px;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    padding-top: 210px;
  }

  * {
    font-family: ${theme.typography.JohnsonsBaby};
  }
`;

export const TitleSection = styled.div`
  text-align: center;
  margin-bottom: 30px;
`;

export const CalendarImage = styled.div`
  margin-bottom: 50px;
  padding: 0 20px;

  @media (min-width: 1450px) {
    margin: 0 -120px 80px;
    padding: 0;
  }

  img {
    width: 100%;
  }
`;

export const Products = styled.div`
  text-align: center;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  width: 100%;
  max-width: 90vw;

  img {
    width: 100%;
    max-width: 745px;
  }
`;

export const MobileContainer = styled.div`
  padding: 0 20px;
`

export const GradientIconContainer = styled.div`
  background: linear-gradient(to bottom, #A2D4EF, #F7DA33);
  padding-bottom: 24px;
  margin-top: -20px;
  padding-top: 20px;
`

export const Ballon = styled.div`
  background-color: ${({ light }) => (light ? '#FFC500' : '#005cb9')};
  color: ${({ light }) => (light ? '#0d5ba8' : 'white')};
  padding: 17px 10px;
  text-align: center;
  position: relative;
  display: inline-block;
  font-size: 15px;
  font-weight: bold;
  width: 100%;
  letter-spacing: -0.02rem;

&.tail {
  margin-bottom: 20px;
  background-color:${({ light }) => (light ? '#EBD94E' : '#075FBB')};;
  &::before {
    content: '';
    position: absolute;
    bottom: -20px;
    left: 50%;
    width: 30px;
    height: 30px;
    background-color: ${({ light }) => (light ? '#EBD94E' : '#005cb9')};
    border-radius: 10px;
    transform: rotate(45deg) translateX(-50%);
    margin-left: -3px;
    clip-path: polygon(100% 0, 0 100%, 100% 100%);
}

}
`

export const Icon = styled.div`
  width: 48px;
  height: 47px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin: 0 auto;
  box-shadow: 1px 1px 0px #FCC800;
`

export const CalendarTitle = styled.div`
  text-align: center;
  font-size: ${({ dots }) => (dots ? '30px' : '20px')};
  font-weight: bold;
  color: #FFD200;
  -webkit-text-stroke: 1px #005cb9;
  text-stroke: 1px #005cb9;
  margin-bottom: 8px;
  text-shadow: 1px 2px 0px #0D5BA8;
  margin-top: ${({ dots }) => (dots ? '-20px' : '8px')};

`

export const CalendarText = styled.div`
  margin-bottom: 24px;
  p {
    font-weight: 400;
    font-size: 14px;
    line-height: 115%;
    text-align: center;
    color: #0D5BA8;
  }

  span {
    font-weight: bold;
  }
`